import { render, staticRenderFns } from "./PostWorkView.vue?vue&type=template&id=0da77f17&scoped=true"
import script from "./PostWorkView.vue?vue&type=script&lang=js"
export * from "./PostWorkView.vue?vue&type=script&lang=js"
import style0 from "./PostWorkView.vue?vue&type=style&index=0&id=0da77f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da77f17",
  null
  
)

export default component.exports